import React from 'react';

import { useSelector } from 'react-redux';
import { LevelUpRoleSelectionSidePanel } from 'screens/Levelup/components/LevelUpRoleSelectionSidePanel/LevelUpRoleSelectionSidePanel';
import { LevelUpPageContextProvider } from 'screens/Levelup/context/provider';
import { AgendaSidePanelContextProvider } from 'screens/oneOnOne/levelUp/agendaSidePanel/context/provider';
import LevelUpDrawer from 'screens/oneOnOne/levelUp/competencySidePanel';
import { LevelUpSidePanelContextProvider } from 'screens/oneOnOne/levelUp/competencySidePanel/context/provider';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import { checkFeedbackModuleEnabled, checkLevelUpModuleEnabled } from 'utils/helpers/moduleAccess';

import ReviewPerformancePreviewCompetencyTable from './ReviewPerformancePreviewCompetencyTable';

const ReviewCompetencyTable = ({ source, isCompetencyEnable }) => {
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);

  if (!isCompetencyEnable || (!checkFeedbackModuleEnabled() && !checkLevelUpModuleEnabled())) return null;

  return (
    <LevelUpPageContextProvider>
      <AgendaSidePanelContextProvider>
        <LevelUpSidePanelContextProvider reportee={loggedInEmployeeId}>
          <ReviewPerformancePreviewCompetencyTable />
          <LevelUpDrawer source={source} />
        </LevelUpSidePanelContextProvider>
      </AgendaSidePanelContextProvider>
      <LevelUpRoleSelectionSidePanel />
    </LevelUpPageContextProvider>
  );
};

export default ReviewCompetencyTable;
